<template>
  <div>
    <Toolbar class="web" />
    <div class="back-btn">
      <v-btn @click="back" class="mx-1" icon color="black">
        <v-icon medium>fas fa-arrow-circle-left</v-icon>
      </v-btn>
      <b>Kembali</b>
    </div>

    <div>
      <v-row class="pa-0">
        <v-col class="d-flex child-flex pa-0" :cols="cols">
          <div class="padding-gambar">
            <v-img
              height="auto"
              width="auto"
              :src="getImageUrl(detailBarang.gambar)"
              :lazy-src="`https://picsum.photos/30/20?image=81`"
              class="grey lighten-2"
            >
              <template v-slot:placeholder>
                <v-row class="fill-height ma-0" align="center" justify="center">
                  <v-progress-circular indeterminate color="grey lighten-5"></v-progress-circular>
                </v-row>
              </template>
            </v-img>
          </div>
        </v-col>
        <v-col>
          <v-card width="75%" height="100%">
            <div class="pa-3">
              <v-icon>fas fa-store</v-icon>
              {{ detailBarang.nama_toko}}
            </div>
            <div class="mx-2 nama-item">
              <b>{{ detailBarang.nama_item }}</b>
            </div>
            <div>
              <v-rating
                v-model="rating"
                readonly
                background-color="purple lighten-3"
                color="purple"
              ></v-rating>
            </div>

            <v-simple-table>
              <template v-slot:default>
                <thead>
                  <tr>
                    <th class="text-left header-item">Harga</th>
                    <th class="text-left header-item">Berat</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td class="harga-item">{{ detailBarang.harga | currency }}</td>
                    <td class="berat-item">{{ detailBarang.berat }} Kg</td>
                  </tr>
                </tbody>
              </template>
            </v-simple-table>
            <div class="my-5">
              <v-textarea
                class="mx-2"
                v-model="catatan"
                hint="Contoh: Warna Putih, Size M"
                label="Catatan"
                rows="1"
                outlined
                dense
                prepend-icon="book"
              ></v-textarea>
            </div>
            <v-divider></v-divider>
            <v-btn class="my-3" @click="buyNow(detailBarang)" block outlined medium>Beli</v-btn>
            <v-btn block @click="addToCart(detailBarang)" outlined medium>Tambah Ke Keranjang</v-btn>
          </v-card>
        </v-col>
      </v-row>
    </div>

    <div>
      <v-container>
        <v-tabs background-color="indigo" dark>
          <v-tab @click="tab(0)">Deskripsi</v-tab>
          <v-tab @click="tab(1)">Ulasan</v-tab>
          <v-tab @click="tab(2)">Diskusi</v-tab>
          <v-tab @click="tab(3)">Rating</v-tab>
          <v-spacer></v-spacer>
          <!-- <v-tab>Item Three</v-tab> -->
        </v-tabs>
        <Deskripsi v-if="tabs == 0" />
      </v-container>
    </div>
    <v-overlay :value="overlay">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
    <v-dialog v-model="dialog" width="700">
      <v-card>
        <v-card-title class="headline grey lighten-2" primary-title>
          Tambah Alamat
          <v-spacer></v-spacer>
          <v-btn @click="dialog = false" icon color="#90A4AE">
            <v-icon>fas fa-times-circle</v-icon>
          </v-btn>
        </v-card-title>
        <div class="pa-5">
          <v-form v-model="valid" lazy-validation ref="alamat">
            <div>
              <v-text-field
                hint="Contoh: Alamat Rumah, Kantor, Apartemen, Dropship"
                :persistent-hint="true"
                label="Nama Alamat"
                placeholder="Alamat Rumah"
                outlined
                required
                v-model="nama_alamat"
                :rules="[(v) => !!v || 'Harap di isi !']"
              ></v-text-field>
            </div>
            <v-row>
              <v-col cols="6">
                <v-text-field
                  required
                  v-model="penerima"
                  :rules="[(v) => !!v || 'Harap di isi !']"
                  label="Nama Penerima"
                  placeholder="Nama penerima barang"
                  outlined
                ></v-text-field>
              </v-col>
              <v-col cols="6">
                <v-text-field
                  hint="Angka [0-9], Contoh: 081234567890"
                  label="Nomor HP"
                  placeholder="Nomor HP penerima barang"
                  :persistent-hint="true"
                  outlined
                  v-model="penerimahp"
                  required
                  :rules="[(v) => !!v || 'Harap di isi !']"
                ></v-text-field>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="6">
                <v-autocomplete
                  v-if="subDistrict"
                  v-model="kecamatan"
                  :rules="[(v) => !!v || 'Wajib di isi']"
                  :items="subDistrict"
                  item-text="Name"
                  item-value="Id"
                  label="Kota atau Kecamatan"
                  flat
                  hide-no-data
                  hide-details
                  outlined
                ></v-autocomplete>
              </v-col>
              <v-col cols="6">
                <v-text-field
                  required
                  :rules="[(v) => !!v || 'Harap di isi !']"
                  placeholder="Kode Pos"
                  label="Kodepos"
                  outlined
                  v-model="kodepos"
                ></v-text-field>
              </v-col>
            </v-row>

            <v-textarea
              required
              v-model="alamat"
              :rules="[(v) => !!v || 'Harap di isi !']"
              placeholder="Alamat pengiriman barang"
              outlined
              autocomplete="text"
              label="Alamat"
            ></v-textarea>
          </v-form>
        </div>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" :disabled="!valid" text @click="subAlamat()">Daftar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import Toolbar from "../../components/Toolbar";
// TABS
import Deskripsi from "../../components/DetailBarang/Deskripsi";
// TABS
import Swal from "sweetalert2";
export default {
  components: {
    Toolbar,
    Deskripsi
  },
  data() {
    return {
      // ALAMAT
      nama_alamat: null,
      penerima: null,
      penerimahp: null,
      kecamatan: null,
      kodepos: null,
      alamat: null,
      subDistrict: [],
      valid: true,
      // alamat
      rating: 4.5,
      overlay: false,
      tabs: 0,
      catatan: null,
      loading: false,
      id: this.$route.params.id,
      detailBarang: [],
      selWarna: null,
      warna: ["Kuning", "Merah", "Biru"],
      pages: 0,
      qtyawal: 0,
      userid: localStorage.getItem("user_id"),
      token: localStorage.getItem("token"),
      alamat_id: localStorage.getItem("alamat_id"),
      beli: false,
      dialog: false
    };
  },
  mounted() {
    this.getData();
    this.getKecamatan();
  },
  computed: {
    height() {
      var x = screen.width;

      if (x < 600) {
        x = 200;
      } else if (600 > x < 960) {
        x = 350;
      } else if (1264 > x < 1904) {
        x = 400;
      }

      return x;
    },
    width() {
      var x = screen.width;

      if (x < 600) {
        x = 200;
      } else if (600 > x < 960) {
        x = 350;
      } else if (1264 > x < 1904) {
        x = 400;
      }

      return x;
    },
    cols() {
      var x = screen.width;

      if (x < 600) {
        x = 12;
      } else if (600 > x < 960) {
        x = 6;
      } else if (1264 > x < 1904) {
        x = 6;
      }

      return x;
    }
  },
  methods: {
    back() {
      window.history.back();
    },
    tab(e) {
      this.tabs = e;
    },
    subAlamat() {
      this.dialog = false;
      this.overlay = true;

      if (this.$refs.alamat.validate()) {
        fetch("http://meridinet.saebo.id:2082/Login/api/tabel/addalamat", {
          method: "POST",
          body: JSON.stringify({
            userid: this.userid,
            nama: "",
            nama_alamat: this.nama_alamat,
            alamat: this.alamat,
            handphone: "",
            subdistrict_id: this.kecamatan,
            kodepos: this.kodepos,
            status: "LAINNYA",
            penerimahp: this.penerimahp,
            penerima: this.penerima
          }),
          headers: {
            "Content-type": "application/json"
          }
        })
          .then(response => response.json())

          .then(data => {
            localStorage.setItem("alamat_id", data.id);
            Swal.fire("Sukses", "Alamat ditambahkan", "success");
            this.overlay = false;
            this.dialog = false;
            window.location.reload();
          });
      } else {
        Swal.fire({
          icon: "error",
          title: "Error",
          text: "Semua Kolom Wajib diisi"
        });
        this.overlay = false;
      }
    },
    getImageUrl(e) {
      var x = e.replace(/\.[^/.]+$/, "");
      return `http://meridinet.saebo.id:2082/TestAPI/api/UploadResponse/Upload/${x}`;
    },
    getData() {
      this.overlay = true;
      fetch(
        "http://meridinet.saebo.id:2082/Login/api/tampil/" +
          this.id +
          "/" +
          this.userid
      )
        .then(response => response.json())
        .then(data => {
          this.detailBarang = data;
          this.overlay = false;
        });
    },
    buyNow(data) {
      if (this.userid != null) {
        this.beli = true;
        fetch("http://meridinet.saebo.id:2082/Login/api/tabel/addchart", {
          method: "POST",
          body: JSON.stringify({
            userid: this.userid,
            nama_toko: data.nama_toko,
            idbarang: data.idbarang,
            qty: 1,
            harga: data.harga,
            catatan: this.catatan,
            kurir: null
          }),
          headers: {
            "Content-Type": "application/json"
          }
        })
          .then(response => response.json())
          .then(data => {
            if (data.Error == 404) {
              this.dialog = true;
            } else if (data.Error != 404) {
              Swal.fire("Sukses", "Barang Ditambahkan", "success");
              this.$router.push("/cart");
            }
          });
      } else if (this.userid == null) {
        this.$router.push("/login");
      }
    },
    getKecamatan() {
      fetch("http://meridinet.saebo.id:2082/Login/api/viewkecamatan")
        .then(response => response.json())
        .then(data => {
          this.subDistrict = data;
        });
    },
    addToCart(data) {
      if (this.userid != null) {
        Swal.fire({
          title: "Jumlah Item yang Dibeli",
          input: "number",
          inputAttributes: {
            autocapitalize: "off"
          },
          showCancelButton: true,
          confirmButtonText: "Ok",
          showLoaderOnConfirm: true,

          allowOutsideClick: () => !Swal.isLoading()
        }).then(result => {
          if (result.value) {
            fetch("http://meridinet.saebo.id:2082/Login/api/tabel/addchart", {
              method: "POST",
              body: JSON.stringify({
                userid: this.userid,
                nama_toko: data.nama_toko,
                idbarang: data.idbarang,
                qty: result.value,
                harga: data.harga,
                catatan: this.catatan,
                kurir: null
              }),
              headers: {
                "Content-type": "application/json"
              }
            })
              .then(response => response.json())
              .then(data => {
                if (data.Error == 404) {
                  this.dialog = true;
                } else if (data.Error != 404) {
                  Swal.fire("Sukses", "Barang Ditambahkan", "success");
                  window.history.back();
                }
              });
          }
        });
      } else if (this.userid == null) {
        this.$router.push("/login");
      }
    }
  }
};
</script>
<style scoped>
@media only screen and (min-width: 1025px) {
  .padding-gambar {
    padding-left: 20%;
    padding-right: 20%;
  }
  .centerImg {
    display: inline-block;
    text-align: center;
  }
  .berat-item {
    font-family: Tahoma, Geneva, sans-serif;
    font-size: 125%;
    letter-spacing: -0.4px;
    word-spacing: 2px;
    color: black;
    font-weight: 700;
    text-decoration: none;
    font-style: normal;
    font-variant: normal;
    text-transform: none;
  }
  .back-btn {
    display: none;
  }
  .header-item {
    font-family: Arial, Helvetica, sans-serif;
    font-size: 125%;
    letter-spacing: 0px;
    word-spacing: 2px;
    color: #100000;
    font-weight: 700;
    text-decoration: none;
    font-style: normal;
    font-variant: normal;
    text-transform: none;
  }
  .harga-item {
    font-family: Tahoma, Geneva, sans-serif;
    font-size: 125%;
    letter-spacing: -0.4px;
    word-spacing: 2px;
    color: #c30000;
    font-weight: 700;
    text-decoration: none;
    font-style: normal;
    font-variant: normal;
    text-transform: none;
  }
  .nama-item {
    font-family: Arial, Helvetica, sans-serif;
    font-size: 200%;
    letter-spacing: 2px;
    word-spacing: 2px;
    color: #000000;
    font-weight: 700;
    text-decoration: none;
    font-style: normal;
    font-variant: normal;
    text-transform: none;
  }
  .deskripsi {
    white-space: pre;
  }
}
@media only screen and (max-width: 1024px) {
  .centerImg {
    display: inline-block;
    text-align: center;
    padding-left: 15%;
  }
}
@media only screen and (max-width: 768px) {
  /* .col {
    padding: 0px !important;
  } */
  .row {
    margin-left: 0px !important;
    margin-right: 0px !important;
  }
  .centerImg {
    display: inline-block;
    text-align: center;
    padding-left: 20%;
  }
}
</style>
